<template>
    <div 
        class="flex pb-[20px]"

    >
        <div class="w-full">
            <div 
                class="pb-[30px] w-max mx-auto"
            >
        
                <div class="balances-width px-4 flex justify-between">
                    <!-- <div class="px-4 mt-3 flex flex-col sm:flex-row sm:flex-wrap sm:justify-between "> -->
                    <div class="p-4 w-1/4">
                        <!-- <div class="p-4 mb-4 sm:mb-0 sm:w-1/4"> -->
                        <balance-card
                            :loading="balancesLoading"
                            :balance="cashboxBalance + wayforpayBalance + bankBalance + investBalance + trainersStudentsBalances"
                            :title="'всі джерела'"
                            :valueColor="'#4A4E69'"
                        />
                    </div>
                    <div class="p-4 w-1/4">
                        <balance-card 
                            :loading="balancesLoading"
                            :balance="cashboxBalance + trainersStudentsBalances"
                            :title="'готівка'"
                            :valueColor="'#4A4E69'"
                        />
                    </div>
                    <div class="p-4 w-1/4 relative">
                        <balance-card
                            @click="showDetailCashless = true" 
                            class="cursor-pointer select-none"
                            :loading="balancesLoading"
                            :balance="wayforpayBalance + bankBalance"
                            :title="'безготівка'"
                            :valueColor="'#4A4E69'"
                        />
                        <div v-if="showDetailCashless" @click="showDetailCashless = false" class="bg-white2 cursor-pointer select-none border-[#D9D9D9] absolute top-[16px] w-[262px] h-[97.5px] border-[1px] border-opacity-10 text-center px-[20px] pt-[9px] pb-[7px] rounded-[10px] flex flex-col items-center justify-center">
                            <div class="mx-[20px] flex items-center justify-start">
                                <div class="text-[15px] text-[#9FA2B4] mr-[10px] w-[50px]">IPay</div>
                                <div class="text-[21px] text-gray-emb font-semibold w-[140px]"><span class="text-[16px]">₴</span>{{ formatNumber(wayforpayBalance) }}</div>
                            </div>
                            <div class="mx-[20px] flex items-center">
                                <div class="text-[15px] text-[#9FA2B4] mr-[10px] w-[50px]">Банк</div>
                                <div class="text-[21px] text-gray-emb font-semibold w-[140px]"><span class="text-[16px]">₴</span>{{ formatNumber(bankBalance) }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="p-4 w-1/4">
                        <balance-card 
                            :loading="balancesLoading"
                            :balance="investBalance"
                            :title="'інвестиції'"
                            :valueColor="'#4A4E69'"
                        />
                    </div>
                </div>
                
        
                <div class="statics-width px-4 flex justify-between">
                    <div class="px-4 w-1/4">
                        <StaticAndFinanceBlock 
                            :loading="subParamsLoading"
                            :value="meanRealIncomeFromStudent"
                            :title="'надходження за день'"
                            type="finance"
                        />
                    </div>
                    <div class="px-4 w-1/4">
                        <StaticAndFinanceBlock 
                            :loading="balancesLoading"
                            :value="trainersStudentsBalances"
                            :title="'готівка у адміністраторів'"
                            type="finance"
                        />
                    </div>
                    <div class="px-4 w-1/4">
                        <StaticAndFinanceBlock 
                            :loading="subParamsLoading"
                            :value="countStudentsWithOverdueTariffs"
                            :title="'застосунок/термінал'"
                            type="static"
                        />
                    </div>
                    <div class="px-4 w-1/4">
                        <StaticAndFinanceBlock
                            :loading="subParamsLoading"
                            :value="percentTrainingsWithAdditionalFilesInCurrentMonth"
                            :title="'середній платіж'"
                            type="percent"
                        />
                    </div>
                </div>
        
                <div class="mt-[30px] incomes-by-sources mx-[30px] py-4 rounded-[20px] px-4 flex justify-between items-center">
                    <IncomesBySource />
        
                    <div class="relative flex h-full flex-col justify-start">
                        <PercentageIncomesBySource />
                    </div>
                </div>
        
                <!-- <div class="px-4 mt-[30px] incomes-groups-container mx-[30px] py-4 rounded-[20px]">
                    <IncomesByGroups />
                </div> -->
        
                <div class="px-4 mt-[30px] mx-[30px] py-4 rounded-[20px] outlays-width">
                    <div class="font-semibold text-gray-emb">
                        ВИТРАТИ
                    </div>
                    <div class="flex justify-between mt-[-50px] relative">
                        <BarChart 
                            v-if="clubOutlaysChartDataLoaded"
                            class="w-max relative top-[70px] left-[15px]"
                            :data="clubOutlaysChartData"
                            :lables="['Січ', 'Лют', 'Бер', 'Квіт', 'Трав', 'Черв', 'Лип', 'Серп', 'Вер', 'Жовт', 'Лист', 'Груд']"
                            :barColor="'#990D35'"
                            :height="290"
                            :width="outlaysBarChartWidth"
                            :key="clubOutlaysChartKey"
                        />
                        <div v-else class="w-[1000px] h-[300px]">
                            <div class="z-[150] absolute w-full h-full top-[50%] left-[38%]">
                                <div class="w-10 h-10 rounded-full animate-spin border-solid border-4 border-[#990D35] border-t-transparent "></div>
                            </div>
                        </div>
                        <div v-if="clubOutlaysChartDataLoaded">
                            <div>
                                <select v-model="outlaysCircleDiagramDate" name="month" class="outline-none rounded-[4px] w-[144px] px-[5px] py-[0.6px] text-start border-[#A4A6B3] text-gray-emb text-[13px] relative top-[18px] left-[75px] cursor-pointer border-[1px] bg-transparent z-[150]">
                                    <option value="1.2023" class="bg-[#FFFFFF]">січень 2023</option>
                                    <option value="2.2023" class="bg-[#FFFFFF]">лютий 2023</option>
                                    <option value="3.2023" class="bg-[#FFFFFF]">березень 2023</option>
                                    <option value="4.2023" class="bg-[#FFFFFF]">квітень 2023</option>
                                    <option value="5.2023" class="bg-[#FFFFFF]">травень 2023</option>
                                    <option value="6.2023" class="bg-[#FFFFFF]">червень 2023</option>
                                    <option value="7.2023" class="bg-[#FFFFFF]">липень 2023</option>
                                    <option value="8.2023" class="bg-[#FFFFFF]">серпень 2023</option>
                                    <option value="9.2023" class="bg-[#FFFFFF]">вересень 2023</option>
                                    <option value="10.2023" class="bg-[#FFFFFF]">жовтень 2023</option>
                                    <option value="11.2023" class="bg-[#FFFFFF]">листопад 2023</option>
                                    <option value="12.2023" class="bg-[#FFFFFF]">грудень 2023</option>
                                </select>
                            </div>
                            <CircleDiagramWithGap :key="showCircleWithGap" :width="outlaysCircleChartWidth" :height="outlaysCircleChartHeight" :segments="clubOutlaysDiagramData" class="w-max h-max relative left-[40px]"/>
                        </div>
                        <div v-else class="w-[350px] h-[300px] relative">
                            <div class="z-[150] absolute w-full h-full top-[50%] left-[65%]">
                                <div class="w-10 h-10 rounded-full animate-spin border-solid border-4 border-[#990D35] border-t-transparent "></div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="px-8 flex justify-between mt-[50px]">
                    <div class="px-4 py-4 rounded-[20px]">
                        <div class="font-semibold mb-[30px] text-gray-emb">
                            ПРИБУТОК
                        </div>
                        <div class="relative flex justify-between z-[30]">
                            <TwoLinesBarChart 
                                v-if="profitChartDataLoaded"
                                :chartData="{
                                    incomes: profitChartIncomesData,
                                    outlays: profitChartOutlaysData,
                                    earnings: profitChartData
                                }" 
                                :key="twoLinesChartLoading" 
                                :width="twoLinesChartWidth" 
                                :height="twoLinesChartHeight"
                                :monthLabels="['січ', 'лют', 'бер', 'кві', 'тра', 'чер', 'лип', 'сер', 'вер', 'жов', 'лис', 'гру']"
                            />
                            <div v-else class="w-[900px] h-[220px] relative">
                                <div class="z-[150] absolute w-full h-full top-[50%] left-[50%]">
                                    <div class="w-10 h-10 rounded-full animate-spin border-solid border-4 border-[#de3a73] border-t-transparent "></div>
                                </div>
                            </div>
                        </div>
                    </div>
        
                    <div class="relative left-[0px] py-4 rounded-[20px]">
                        <div class="font-semibold text-center text-gray-emb">
                            ЗА ВЕСЬ РІК
                        </div>
                        <div class="all-income-params flex flex-col justify-between pt-[35px] pb-[30px]">
                            <div class="text-center text-green-emb relative top-[12px]">
                                <div v-if="profitChartSumLoaded" class="text-[21px] font-semibold">{{ profitChartIncomesSum.toLocaleString() }}</div>
                                <div v-else class="relative bottom-[5px] mx-auto mb-[6px] rounded-full animate-pulse mt-[5px] text-2xl w-[70px] h-[20px] bg-green-emb bg-opacity-25"></div>
                                <div class="leading-[5px] text-[12px] relative top-[10px]">дохід</div>
                            </div>
                            <div class="text-center text-[#525A60] relative top-[px]">
                                <div v-if="profitChartSumLoaded" class="text-[21px] relative bottom-[10px] font-semibold">{{ profitChartDataSum.toLocaleString() }}</div>
                                <div v-else class="relative bottom-[10px] mx-auto mb-[10px] rounded-full animate-pulse mt-[5px] text-2xl w-[70px] h-[20px] bg-[#DFF726] bg-opacity-25"></div>
                                <div class="leading-[5px] text-[12px]">прибуток</div>
                            </div>
                            <div class="text-center text-[#990D35] relative bottom-[40px]">
                                <div v-if="profitChartSumLoaded" class="text-[21px] font-semibold">{{ profitChartOutlaysSum.toLocaleString() }}</div>
                                <div v-else class="relative bottom-[5px] mx-auto mb-[6px] rounded-full animate-pulse mt-[5px] text-2xl w-[70px] h-[20px] bg-[#990D35] bg-opacity-25"></div>
                                <div class="leading-[5px] text-[12px] relative top-[10px]">витрати</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mb-[20px]">
                    <div class="flex items-center justify-between pr-[80px]">
                        <div class="font-semibold text-start pl-[30px] text-gray-emb">
                            СПІВВІДНОШЕННЯ КЛІЄНТІВ
                        </div>

                        <div class="flex gap-[10px]">
                            <select v-model="clientGroupYear" name="year" class="outline-none rounded-[4px] w-[144px] px-[5px] py-[0.6px] text-start border-[#A4A6B3] text-gray-emb text-[13px] relative cursor-pointer border-[1px] bg-transparent z-[150]">
                                <option value="2024" class="bg-[#FFFFFF]">2024</option>
                                <option value="2025" class="bg-[#FFFFFF]">2025</option>
                            </select>
                            <select v-model="clientGroupMonth" name="month" class="outline-none rounded-[4px] w-[144px] px-[5px] py-[0.6px] text-start border-[#A4A6B3] text-gray-emb text-[13px] relative cursor-pointer border-[1px] bg-transparent z-[150]">
                                <option value="1" class="bg-[#FFFFFF]">січень</option>
                                <option value="2" class="bg-[#FFFFFF]">лютий</option>
                                <option value="3" class="bg-[#FFFFFF]">березень</option>
                                <option value="4" class="bg-[#FFFFFF]">квітень</option>
                                <option value="5" class="bg-[#FFFFFF]">травень</option>
                                <option value="6" class="bg-[#FFFFFF]">червень</option>
                                <option value="7" class="bg-[#FFFFFF]">липень</option>
                                <option value="8" class="bg-[#FFFFFF]">серпень</option>
                                <option value="9" class="bg-[#FFFFFF]">вересень</option>
                                <option value="10" class="bg-[#FFFFFF]">жовтень</option>
                                <option value="11" class="bg-[#FFFFFF]">листопад</option>
                                <option value="12" class="bg-[#FFFFFF]">грудень</option>
                            </select>
                        </div>
                    </div>
                    <div class="statics-width mt-[15px] px-4 flex ">
                        <div class="w-1/3 flex justify-center">
                            <StaticAndFinanceBlock 
                                :loading="clientGroupStatisticsLoading"
                                :value="clientGroupStatistics?.newbees?.summ"
                                :title="'нові клієнти (1 місяць)'"
                                type="static"
                            />
                        </div>
                        <div class="w-1/3 flex justify-center">
                            <StaticAndFinanceBlock 
                                :loading="clientGroupStatisticsLoading"
                                :value="clientGroupStatistics?.active?.summ"
                                :title="'середні клієнти (2-6 місяців)'"
                                type="static"
                            />
                        </div>
                        <div class="w-1/3 flex justify-center">
                            <StaticAndFinanceBlock 
                                :loading="clientGroupStatisticsLoading"
                                :value="clientGroupStatistics?.old?.summ"
                                :title="'старі клієнти (6+ місяців)'"
                                type="static"
                            />
                        </div>
                    </div>
                </div>
                <div class="mb-[20px]">
                    <div class="flex items-center justify-between pr-[80px]">
                        <div class="font-semibold text-start pl-[30px] text-gray-emb">
                            КЛІЄНТИ ЯКІ ПРИДБАЛИ БАГАТОРАЗОВИЙ АБОНЕМЕНТ
                        </div>

                        <div class="flex gap-[10px]">
                            <select v-model="multiTariffsYear" name="year" class="outline-none rounded-[4px] w-[144px] px-[5px] py-[0.6px] text-start border-[#A4A6B3] text-gray-emb text-[13px] relative cursor-pointer border-[1px] bg-transparent z-[150]">
                                <option value="2024" class="bg-[#FFFFFF]">2024</option>
                                <option value="2025" class="bg-[#FFFFFF]">2025</option>
                            </select>
                            <select v-model="multiTariffsMonth" name="month" class="outline-none rounded-[4px] w-[144px] px-[5px] py-[0.6px] text-start border-[#A4A6B3] text-gray-emb text-[13px] relative cursor-pointer border-[1px] bg-transparent z-[150]">
                                <option value="1" class="bg-[#FFFFFF]">січень</option>
                                <option value="2" class="bg-[#FFFFFF]">лютий</option>
                                <option value="3" class="bg-[#FFFFFF]">березень</option>
                                <option value="4" class="bg-[#FFFFFF]">квітень</option>
                                <option value="5" class="bg-[#FFFFFF]">травень</option>
                                <option value="6" class="bg-[#FFFFFF]">червень</option>
                                <option value="7" class="bg-[#FFFFFF]">липень</option>
                                <option value="8" class="bg-[#FFFFFF]">серпень</option>
                                <option value="9" class="bg-[#FFFFFF]">вересень</option>
                                <option value="10" class="bg-[#FFFFFF]">жовтень</option>
                                <option value="11" class="bg-[#FFFFFF]">листопад</option>
                                <option value="12" class="bg-[#FFFFFF]">грудень</option>
                            </select>
                        </div>
                    </div>
                    <div class="statics-width mt-[15px] px-4 flex ">
                        <div class="w-1/3 flex justify-center">
                            <StaticAndFinanceBlock 
                                :loading="multiTariffsClientsStatisticsLoading"
                                :value="multiTariffsClientsStatistics?.multi_tariffs?.Personal.total + multiTariffsClientsStatistics?.multi_tariffs?.Split.total + multiTariffsClientsStatistics?.multi_tariffs?.Team.total"
                                :title="'всього'"
                                type="static"
                            />
                        </div>
                        <div class="w-1/3 flex flex-col items-center justify-center">
                            <StaticAndFinanceBlock 
                                :loading="multiTariffsClientsStatisticsLoading"
                                :value="multiTariffsClientsStatistics?.multi_tariffs?.Team.total"
                                :title="'групові'"
                                type="static"
                            />
                            <div>
                                <div>4 заняття - {{multiTariffsClientsStatistics?.multi_tariffs?.Team.by_tariff['4']}}</div>
                                <div>8 заняття - {{multiTariffsClientsStatistics?.multi_tariffs?.Team.by_tariff['8']}}</div>
                                <div>10 заняття - {{multiTariffsClientsStatistics?.multi_tariffs?.Team.by_tariff['10']}}</div>
                            </div>
                        </div>
                        <div class="w-1/3 flex flex-col items-center justify-center">
                            <StaticAndFinanceBlock 
                                :loading="multiTariffsClientsStatisticsLoading"
                                :value="multiTariffsClientsStatistics?.multi_tariffs?.Split.total"
                                :title="'дуо'"
                                type="static"
                            />
                            <div>
                                <div>4 заняття - {{multiTariffsClientsStatistics?.multi_tariffs?.Split.by_tariff['4']}}</div>
                                <div>8 заняття - {{multiTariffsClientsStatistics?.multi_tariffs?.Split.by_tariff['8']}}</div>
                                <div>10 заняття - {{multiTariffsClientsStatistics?.multi_tariffs?.Split.by_tariff['10']}}</div>
                            </div>
                        </div>
                        <div class="w-1/3 flex flex-col items-center justify-center">
                            <StaticAndFinanceBlock 
                                :loading="multiTariffsClientsStatisticsLoading"
                                :value="multiTariffsClientsStatistics?.multi_tariffs?.Personal.total"
                                :title="'індивідуальні'"
                                type="static"
                            />
                            <div>
                                <div>4 заняття - {{multiTariffsClientsStatistics?.multi_tariffs?.Personal.by_tariff['4']}}</div>
                                <div>8 заняття - {{multiTariffsClientsStatistics?.multi_tariffs?.Personal.by_tariff['8']}}</div>
                                <div>10 заняття - {{multiTariffsClientsStatistics?.multi_tariffs?.Personal.by_tariff['10']}}</div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-[15px]">
                        <ClientStatisticChart   
                            :months="['Янв','Фев','Мар','Апр','Май','Июн','Июл','Авг','Сен','Окт','Ноя','Дек']"
                            :seriesData="[
                                { name: 'групові', data: multiGroupTypeMonthes },
                                { name: 'дуо', data: multiDuoTypeMonthes },
                                { name: 'індивідуальні', data: multiSoloTypeMonthes }
                            ]" 
                        />
                    </div>
                </div>
                <div class="mb-[20px]">
                    <div class="flex items-center justify-between pr-[80px]">
                        <div class="font-semibold text-start pl-[30px] text-gray-emb">
                            КЛІЄНТИ ЯКІ ПРИДБАЛИ ОДНОРАЗОВИЙ АБОНЕМЕНТ
                        </div>

                        <div class="flex gap-[10px]">
                            <select v-model="singleTariffsYear" name="year" class="outline-none rounded-[4px] w-[144px] px-[5px] py-[0.6px] text-start border-[#A4A6B3] text-gray-emb text-[13px] relative cursor-pointer border-[1px] bg-transparent z-[150]">
                                <option value="2024" class="bg-[#FFFFFF]">2024</option>
                                <option value="2025" class="bg-[#FFFFFF]">2025</option>
                            </select>
                            <select v-model="singleTariffsMonth" name="month" class="outline-none rounded-[4px] w-[144px] px-[5px] py-[0.6px] text-start border-[#A4A6B3] text-gray-emb text-[13px] relative cursor-pointer border-[1px] bg-transparent z-[150]">
                                <option value="1" class="bg-[#FFFFFF]">січень</option>
                                <option value="2" class="bg-[#FFFFFF]">лютий</option>
                                <option value="3" class="bg-[#FFFFFF]">березень</option>
                                <option value="4" class="bg-[#FFFFFF]">квітень</option>
                                <option value="5" class="bg-[#FFFFFF]">травень</option>
                                <option value="6" class="bg-[#FFFFFF]">червень</option>
                                <option value="7" class="bg-[#FFFFFF]">липень</option>
                                <option value="8" class="bg-[#FFFFFF]">серпень</option>
                                <option value="9" class="bg-[#FFFFFF]">вересень</option>
                                <option value="10" class="bg-[#FFFFFF]">жовтень</option>
                                <option value="11" class="bg-[#FFFFFF]">листопад</option>
                                <option value="12" class="bg-[#FFFFFF]">грудень</option>
                            </select>
                        </div>
                    </div>
                    <div class="statics-width mt-[15px] px-4 flex ">
                        <div class="w-1/3 flex justify-center">
                            <StaticAndFinanceBlock 
                                :loading="singleTariffsClientsStatisticsLoading"
                                :value="singleTariffsClientsStatistics?.single_tariffs?.Personal + singleTariffsClientsStatistics?.single_tariffs?.Split + singleTariffsClientsStatistics?.single_tariffs?.Team"
                                :title="'всього'"
                                type="static"
                            />
                        </div>
                        <div class="w-1/3 flex justify-center">
                            <StaticAndFinanceBlock 
                                :loading="singleTariffsClientsStatisticsLoading"
                                :value="singleTariffsClientsStatistics?.single_tariffs?.Team"
                                :title="'групові'"
                                type="static"
                            />
                        </div>
                        <div class="w-1/3 flex justify-center">
                            <StaticAndFinanceBlock 
                                :loading="singleTariffsClientsStatisticsLoading"
                                :value="singleTariffsClientsStatistics?.single_tariffs?.Split"
                                :title="'дуо'"
                                type="static"
                            />
                        </div>
                        <div class="w-1/3 flex justify-center">
                            <StaticAndFinanceBlock 
                                :loading="singleTariffsClientsStatisticsLoading"
                                :value="singleTariffsClientsStatistics?.single_tariffs?.Personal"
                                :title="'індивідуальні'"
                                type="static"
                            />
                        </div>
                    </div>

                    <div class="mt-[15px]">
                        <ClientStatisticChart   
                            :months="['Янв','Фев','Мар','Апр','Май','Июн','Июл','Авг','Сен','Окт','Ноя','Дек']"
                            :seriesData="[
                                { name: 'групові', data: singleGroupTypeMonthes },
                                { name: 'дуо', data: singleDuoTypeMonthes },
                                { name: 'індивідуальні', data: singleSoloTypeMonthes }
                            ]" 
                        />
                    </div>
                </div>

        
                <div class="px-8 mt-[30px] mb-[50px]">
                    <div class="font-semibold text-gray-emb">
                        АНАЛІТИКА ПО ТРЕНЕРАХ
                    </div>
                    <div class="w-[100%] mt-[30px]">
                        <table class="w-full">
                            <thead>
                                <tr class="text-gray-emb h-[14px]">
                                    <th class="border-x-[1px] leading-[0] border-opacity-[45%] border-gray-emb text-[12px] font-normal w-[8%]">фото</th>
                                    <th class="border-x-[1px] leading-[0] border-opacity-[45%] border-gray-emb text-[12px] font-normal w-[14%] text-center">тренер</th>
                                    <th class="border-x-[1px] leading-[0] border-opacity-[45%] border-gray-emb text-[12px] font-normal">динаміка проведених тренувань</th>
                                    <th class="border-x-[1px] leading-[0] border-opacity-[45%] border-gray-emb text-[12px] font-normal">зароблено грошей тренером</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colspan="6" class="h-[20px]"></td>
                                </tr>
                                <trainer-row 
                                    v-if="trainersList.length > 0"
                                    v-for="trainer in trainersList" 
                                    :trainer="trainer"
                                />
                                <tr v-else>
                                    <td colspan="6">
                                        <div class="w-full h-[200px] relative">
                                            <div class="z-[150] absolute w-full h-full top-[50%] left-[50%]">
                                                <div class="w-10 h-10 rounded-full animate-spin border-solid border-4 border-[#990D35] border-t-transparent "></div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
        
            </div>
        </div>
    </div>
</template>

<script>
    import { getServiceBalanceByLabel, getAllTrainerStudentBalanceState, 
        getAllCashFromAdmins, getAllInvestFromAdmins, 
        getSumOfAllVirtualOutlays, getAllVirtualOutlaysCount, 
        getMeanRealIncomeFromStudent, getStatisticsClubOutlaysByYear, getYearIncomesBySources,
        getAllGroups, getAllTrainers, getStudentsCountByGroupId, getTrainerCompletedTrainingsByYear, 
        getAllIncomesByGroupInYear, getCountStudentsWithOverdueTariffs, getPercentTrainingsWithAdditionalFilesInCurrentMonth, 
        getTrainerCompletedTrainingsByMonthes, getTrainerClientsByMonthes, getTrainerEarnedMoneyByMonthes, getClientsGroupsStatistics, getMultiTariffsClientsStatistics, getSingleTariffsClientsStatistics } from '@/services/apiRequests'
    import { ref, onMounted, watch } from 'vue'
    import { uuid } from 'vue3-uuid'
    import BalanceCard from './components/BalanceCard.vue'
    import StaticAndFinanceBlock from './components/StaticAndFinanceBlock.vue'
    import CircleDiagram from './components/CircleDiagram.vue'
    import BarOverlineChart from './components/BarOverlineChart.vue'
    import BarChart from './components/BarChart.vue'
    import CircleDiagramWithGap from './components/CircleDiagramWithGap.vue'
    import TwoLinesBarChart from './components/TwoLinesBarChart.vue'
    import MinLineChart from './components/MinLineChart.vue'
    import MinBarChart from './components/MinBarChart.vue'
    import ClientStatisticChart from './components/ClientStatisticChart.vue'

    import IncomesBySource from './components/DashboardComponents/IncomesBySource.vue'
    import PercentageIncomesBySource from './components/DashboardComponents/PercentageIncomesBySource.vue'
    import IncomesByGroups from './components/DashboardComponents/IncomesByGroups.vue'
    import TrainerRow from './components/DashboardComponents/TrainerRow.vue'

    export default {
        name: 'Finance', 

        setup() {
            const wayforpayBalance = ref(0)
            const bankBalance = ref(0)
            const cashboxBalance = ref(0)
            const investBalance = ref(0)
            const trainersStudentsBalances = ref(0)
            const balancesLoading = ref(true)

            const sumOfAllVirtualOutlays = ref(0)
            const allVirtualOutlaysCount = ref(0)
            const meanRealIncomeFromStudent = ref(0)
            const subParamsLoading = ref(true)

            const showCircleWithGap = ref(uuid.v4())
            const screenWidth = ref(window.innerWidth)

            const clubOutlaysStatistics = ref([])
            const clubOutlaysStatisticsYear = ref(new Date().getFullYear())
            const clubOutlaysStatisticsMonth = ref(new Date().getMonth())
            const clubOutlaysChartData = ref([])
            const clubOutlaysDiagramData = ref([])
            const clubOutlaysChartKey = ref(uuid.v4())

            const profitChartYear = ref(new Date().getFullYear())
            const profitChartIncomesData = ref([])
            const profitChartIncomesSum = ref(0)
            const profitChartOutlaysData = ref([])
            const profitChartOutlaysSum = ref(0)
            const profitChartData = ref([])
            const profitChartDataSum = ref(0)
            const profitChartDataLoaded = ref(false)
            const profitChartSumLoaded = ref(false)
            const allTrainers = ref([])
            const allGroups = ref([])

            const countStudentsWithOverdueTariffs = ref(0)
            const percentTrainingsWithAdditionalFilesInCurrentMonth = ref(0)

            const showDetailCashless = ref(false)

            const trainersList = ref([])
            
            const getTrainersStatistics = async () => {
                const trainersStatisticsRes = await getAllTrainers()
                const trainers = trainersStatisticsRes.data

                let trainersWithCompletedTrainings = []

                for (let i = 0; i < trainers.length; i++) {
                    const completedTrainingsRes = await getTrainerCompletedTrainingsByMonthes(new Date().getFullYear(), trainers[i].trainer_id)
                    const completedTrainings = completedTrainingsRes.data

                    const trainerClientsRes = await getTrainerClientsByMonthes(new Date().getFullYear(), trainers[i].trainer_id)
                    const trainerClients = trainerClientsRes.data

                    const trainerEarnedMoneyRes = await getTrainerEarnedMoneyByMonthes(new Date().getFullYear(), trainers[i].trainer_id)
                    const trainerEarnedMoney = trainerEarnedMoneyRes.data

                    console.log('trainerClients ------------- ', trainerClients)

                    trainersWithCompletedTrainings.push({
                        photo: trainers[i].photo,
                        trainer_name: trainers[i].surname + ' ' + trainers[i].name[0] + '.',
                        completed_trainings: completedTrainings.map(training => training.trainings),
                        trainer_clients: trainerClients.map(client => client.clients),
                        earned_money: trainerEarnedMoney.map(money => money.money)
                    })
                }

                trainersList.value = trainersWithCompletedTrainings

            }

            //outlays circle chart
            const outlaysCircleChartHeight = ref(330)
            const outlaysCircleChartWidth = ref(300)

            const resizeOutlaysCircleChart = () => {
                if (screenWidth.value < 1410) {
                    outlaysCircleChartHeight.value = 230
                    outlaysCircleChartWidth.value = 200
                } else {
                    outlaysCircleChartHeight.value = 330
                    outlaysCircleChartWidth.value = 300
                }
                showCircleWithGap.value = uuid.v4()
            }

            watch(() => window.innerWidth, () => {
                screenWidth.value = window.innerWidth
            })

            watch(screenWidth, () => {
                resizeOutlaysCircleChart()
            })

            //outlays block
            const outlaysBarChartHeight = ref(127)
            const outlaysBarChartWidth = ref(790)

            const resizeOutlaysBlock = () => {
                if (screenWidth.value < 1410) {
                    outlaysBarChartHeight.value = 300
                    outlaysBarChartWidth.value = 600
                } else {
                    outlaysBarChartHeight.value = 367
                    outlaysBarChartWidth.value = 790
                }
            }

            watch(screenWidth, () => {
                resizeOutlaysBlock()
            })

            //two lines chart
            const twoLinesChartHeight = ref(400)
            const twoLinesChartWidth = ref(790)
            const twoLinesChartLoading = ref(uuid.v4())
            const outlaysCircleDiagramDate = ref('11.2023')

            const resizeTwoLinesChart = () => {
                if (screenWidth.value < 1410) {
                    twoLinesChartHeight.value = 300
                    twoLinesChartWidth.value = 630
                } else {
                    twoLinesChartHeight.value = 400
                    twoLinesChartWidth.value = 790
                }
                twoLinesChartLoading.value = uuid.v4()
            }

            watch(screenWidth, () => {
                resizeTwoLinesChart()
            })
 

            const allYearsClubOutlaysStatistics = ref([])
            const clubOutlaysChartDataLoaded = ref(false)

            const updateClubOutlaysDiagram = () => {
                let segments = []
                const currentOutlayStatisticMonth = allYearsClubOutlaysStatistics.value.find(outlay => outlay.date_format == outlaysCircleDiagramDate.value)
                console.log('currentOutlayStatisticMonth ------ ', currentOutlayStatisticMonth)

                if (currentOutlayStatisticMonth) {
                    currentOutlayStatisticMonth.categories.forEach(category => {
                        segments.push({
                            label: category.category_name,
                            value: category.outlays_sum
                        })
                    })
                    clubOutlaysDiagramData.value = segments
                } else {
                    clubOutlaysDiagramData.value = []
                }
                showCircleWithGap.value = uuid.v4()
            }

            const updateOutlaysChart = async () => {
                const clubOutlaysStatisticsRes = await getStatisticsClubOutlaysByYear(clubOutlaysStatisticsYear.value)
                allYearsClubOutlaysStatistics.value = clubOutlaysStatisticsRes 

                for (let i = 1; i <= 12; i++) {
                    let currentOutlay = allYearsClubOutlaysStatistics.value.find(outlay => outlay.date_format.split('.')[0] === `${i}`)
                    if (currentOutlay) {
                        clubOutlaysChartData.value.push(currentOutlay.total_outlays_sum) 
                    } else {
                        clubOutlaysChartData.value.push(0)
                    }
                }

                updateClubOutlaysDiagram()

                clubOutlaysChartDataLoaded.value = true
                clubOutlaysChartKey.value = uuid.v4()
                showCircleWithGap.value = uuid.v4()
            }

            watch(outlaysCircleDiagramDate, () => {
                updateClubOutlaysDiagram()
            })

            const updateProfitChart = async () => {
                const clubOutlaysStatisticsRes = await getStatisticsClubOutlaysByYear(profitChartYear.value)
                const yearIncomesStatistics = await getYearIncomesBySources(profitChartYear.value)

                
                for (let i = 1; i <= 12; i++) {
                    const currentMonthIncome = yearIncomesStatistics.find(income => income.date_formatted.split('.')[0] == i)
                    if (currentMonthIncome) {
                        profitChartIncomesData.value.push(currentMonthIncome.all_incomes)    
                    } else {
                        profitChartIncomesData.value.push(0)
                    }

                    const currentMonthOutlay = clubOutlaysStatisticsRes.find(outlay => outlay.date_format.split('.')[0] == i)
                    if (currentMonthOutlay) {
                        profitChartOutlaysData.value.push(currentMonthOutlay.total_outlays_sum)    
                    } else {
                        profitChartOutlaysData.value.push(0)
                    }

                    profitChartData.value.push(profitChartIncomesData.value[profitChartIncomesData.value.length - 1] - profitChartOutlaysData.value[profitChartOutlaysData.value.length - 1])
                }

                profitChartDataLoaded.value = true

                profitChartIncomesSum.value = profitChartIncomesData.value.reduce((sum, current) => sum + current, 0)
                profitChartOutlaysSum.value = profitChartOutlaysData.value.reduce((sum, current) => sum + current, 0)
                profitChartDataSum.value = profitChartData.value.reduce((sum, current) => sum + current, 0)
                profitChartSumLoaded.value = true
            }

            const trainersDataLoaded = ref(true)
            const getAllTrainersAndGroups = async () => {
                const allTrainersRes = await getAllTrainers()
                allTrainers.value = allTrainersRes.data
                const allGroupsRes = await getAllGroups()
                allGroups.value = allGroupsRes.data
            }

            const studentsInGroups = ref([])
            const allStudentsCount = ref(0)
            const studentsInGroupsLoaded = ref(false)
            const countStudentsInGroups = async () => {
                let studentsCount = 0

                for (let i = 0; i < allGroups.value.length; i++) {
                    const res = await getStudentsCountByGroupId(allGroups.value[i].group_id)
                    studentsInGroups.value.push({
                        group_name: allGroups.value[i].name,
                        students_count: res.data
                    })
                    
                    studentsCount += res.data
                }

                allStudentsCount.value = studentsCount
                studentsInGroupsLoaded.value = true
            }

            const trainersGroupsStats = ref([])
            const trainersGroupsStatistics = async () => {
                let trainersGroupsStatistics = []
                const incomesRes = await getAllIncomesByGroupInYear(new Date().getFullYear())
                const incomes = incomesRes.data
                console.log('incomes ------------- ', incomes)
                for (let i = 0; i < allTrainers.value.length; i++) {
                    let groupsCount = 0
                    let studentsGroupsCount = 0
                    let trainersGroupIds = []
                    for (let j = 0; j < allGroups.value.length; j++) {
                        if (allGroups.value[j].trainer_id === allTrainers.value[i].trainer_id) {
                            trainersGroupIds.push(allGroups.value[j].group_id)
                            groupsCount++
                            studentsGroupsCount += studentsInGroups.value.find(studentsInGroup => studentsInGroup.group_name === allGroups.value[j].name).students_count
                        }
                    }
                 
                    const completedTrainingsRes = await getTrainerCompletedTrainingsByYear(new Date().getFullYear(), allTrainers.value[i].trainer_id)
                    console.log('completedTrainingsRes ------------- ', completedTrainingsRes)

                    const trainerGroupsIncomes = []

                    for (let i = 1; i <= 12; i++) {
                        const currentMonthIncome = incomes.find(income => i <= 9 ? income.date_formatted.split('.')[0].includes(`0${i}`) : income.date_formatted.split('.')[0].includes(`${i}`))
                        let allCurrentMonthIncomes = 0

                        if (currentMonthIncome) {
                            currentMonthIncome.groups.forEach(group => {
                                if (trainersGroupIds.includes(group.group_id)) {
                                    allCurrentMonthIncomes += group.all_incomes
                                }
                            })
                        }
                        
                        trainerGroupsIncomes.push(allCurrentMonthIncomes)
                    }

                    trainersGroupsStatistics.push({
                        photo: allTrainers.value[i].photo,
                        trainer_name: allTrainers.value[i].surname + ' ' + allTrainers.value[i].name[0] + '.',
                        groups_count: groupsCount,
                        students_count: studentsGroupsCount,
                        completed_trainings_count: completedTrainingsRes.data,
                        trainer_groups_incomes: trainerGroupsIncomes
                    })
                }

                trainersDataLoaded.value = true
                return trainersGroupsStatistics
            }

            const formatNumber = (number) => {
                const parts = number.toFixed(2).toString().split('.');
                const integerPart = parts[0];
                const decimalPart = parts[1];

                const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

                const formattedNumber = formattedInteger + '.' + decimalPart;

                return formattedNumber;
            }

            const clientGroupYear = ref(new Date().getFullYear())
            const clientGroupMonth = ref(new Date().getMonth() + 1)
            const clientGroupStatistics = ref([])
            const clientGroupStatisticsLoading = ref(true)

            watch([clientGroupYear, clientGroupMonth], async () => {
                clientGroupStatisticsLoading.value = true
                clientGroupStatistics.value = (await getClientsGroupsStatistics(+clientGroupYear.value, +clientGroupMonth.value)).data
                console.log('clientGroupStatistics.value ------------- ', clientGroupStatistics.value)
                clientGroupStatisticsLoading.value = false
            })

            const multiTariffsClientsStatistics = ref([])
            const multiTariffsClientsStatisticsLoading = ref(true)
            const multiTariffsYear = ref(new Date().getFullYear())
            const multiTariffsMonth = ref(new Date().getMonth() + 1)

            watch([multiTariffsYear, multiTariffsMonth], async () => {
                multiTariffsClientsStatisticsLoading.value = true
                const multiTariffsRes = await getMultiTariffsClientsStatistics(+multiTariffsYear.value, +multiTariffsMonth.value)
                multiTariffsClientsStatistics.value = multiTariffsRes.data
                console.log('multiTariffsClientsStatistics.value ------------- ', multiTariffsClientsStatistics.value)
                multiTariffsClientsStatisticsLoading.value = false
            })

            const multiGroupTypeMonthes = ref([])
            const multiDuoTypeMonthes = ref([])
            const multiSoloTypeMonthes = ref([])

            const getAllMonthesMultiTariffsStatistics = async () => {
                let firstMonth = 1

                for (let i = 0; i < 12; i++) {
                    const multiTariffsRes = await getMultiTariffsClientsStatistics(+new Date().getFullYear(), firstMonth)
                    
                    if (multiTariffsRes?.data?.multi_tariffs.Personal.total) {
                        multiSoloTypeMonthes.value.push(multiTariffsRes.data.multi_tariffs.Personal.total)
                    } else {
                        multiSoloTypeMonthes.value.push(0)
                    }

                    if (multiTariffsRes?.data?.multi_tariffs.Split.total) {
                        multiDuoTypeMonthes.value.push(multiTariffsRes.data.multi_tariffs.Split.total)
                    } else {
                        multiDuoTypeMonthes.value.push(0)
                    }

                    if (multiTariffsRes?.data?.multi_tariffs.Team.total) {
                        multiGroupTypeMonthes.value.push(multiTariffsRes.data.multi_tariffs.Team.total)
                    } else {
                        multiGroupTypeMonthes.value.push(0)
                    }
                 
                    firstMonth++
                }

                console.log('multiGroupTypeMonthes.value ------------- ', multiGroupTypeMonthes.value)
                console.log('multiDuoTypeMonthes.value ------------- ', multiDuoTypeMonthes.value)
                console.log('multiSoloTypeMonthes.value ------------- ', multiSoloTypeMonthes.value)
            }

            const singleTariffsClientsStatistics = ref([])
            const singleTariffsClientsStatisticsLoading = ref(true)
            const singleTariffsYear = ref(new Date().getFullYear())
            const singleTariffsMonth = ref(new Date().getMonth() + 1)

            watch([singleTariffsYear, singleTariffsMonth], async () => {
                singleTariffsClientsStatisticsLoading.value = true
                const singleTariffsRes = await getSingleTariffsClientsStatistics(+singleTariffsYear.value, +singleTariffsMonth.value)
                singleTariffsClientsStatistics.value = singleTariffsRes.data
                console.log('singleTariffsClientsStatistics.value ------------- ', singleTariffsClientsStatistics.value)
                singleTariffsClientsStatisticsLoading.value = false
            })

            const allMonthesSingleTariffsStatistics = ref([])
            const singleGroupTypeMonthes = ref([])
            const singleDuoTypeMonthes = ref([])
            const singleSoloTypeMonthes = ref([])

            const getAllMonthesSingleTariffsStatistics = async () => {
                let firstMonth = 1

                for (let i = 0; i < 12; i++) {
                    const singleTariffsRes = await getSingleTariffsClientsStatistics(+new Date().getFullYear(), firstMonth)
                    
                    if (singleTariffsRes?.data?.single_tariffs.Personal) {
                        singleSoloTypeMonthes.value.push(singleTariffsRes.data.single_tariffs.Personal)
                    } else {
                        singleSoloTypeMonthes.value.push(0)
                    }

                    if (singleTariffsRes?.data?.single_tariffs.Split) {
                        singleDuoTypeMonthes.value.push(singleTariffsRes.data.single_tariffs.Split)
                    } else {
                        singleDuoTypeMonthes.value.push(0)
                    }

                    if (singleTariffsRes?.data?.single_tariffs.Team) {
                        singleGroupTypeMonthes.value.push(singleTariffsRes.data.single_tariffs.Team)
                    } else {
                        singleGroupTypeMonthes.value.push(0)
                    }
                 
                    allMonthesSingleTariffsStatistics.value.push(singleTariffsRes.data)
                    firstMonth++
                }

                console.log('singleGroupTypeMonthes.value ------------- ', singleGroupTypeMonthes.value)
                console.log('singleDuoTypeMonthes.value ------------- ', singleDuoTypeMonthes.value)
                console.log('singleSoloTypeMonthes.value ------------- ', singleSoloTypeMonthes.value)
            }

            onMounted(async () => {
                const wayforpayBalanceRes = await getServiceBalanceByLabel('IPay')
                wayforpayBalance.value = wayforpayBalanceRes.state
                const bankBalanceRes = await getServiceBalanceByLabel('Bank')
                bankBalance.value = bankBalanceRes.state
                const cashboxBalanceRes = await getAllCashFromAdmins()
                cashboxBalance.value = cashboxBalanceRes.balance_state
                const investBalanceRes = await getAllInvestFromAdmins()
                investBalance.value = investBalanceRes.balance_state
                const allTrainerStudentsBalanceRes = await getAllTrainerStudentBalanceState('AllTrainerStudents')
                trainersStudentsBalances.value = allTrainerStudentsBalanceRes.balance_state
                balancesLoading.value = false

                const sumOfAllVirtualOutlaysRes = await getSumOfAllVirtualOutlays()
                sumOfAllVirtualOutlays.value = sumOfAllVirtualOutlaysRes.sum
                const allVirtualOutlaysCountRes = await getAllVirtualOutlaysCount()
                allVirtualOutlaysCount.value = allVirtualOutlaysCountRes.count
                const meanRealIncomeFromStudentRes = await getMeanRealIncomeFromStudent()
                meanRealIncomeFromStudent.value = meanRealIncomeFromStudentRes.mean
                const countStudentsWithOverdueTariffsRes = await getCountStudentsWithOverdueTariffs()
                countStudentsWithOverdueTariffs.value = countStudentsWithOverdueTariffsRes
                // const percentTrainingsWithAdditionalFilesInCurrentMonthRes = await getPercentTrainingsWithAdditionalFilesInCurrentMonth()
                percentTrainingsWithAdditionalFilesInCurrentMonth.value = 0
                console.log('percentTrainingsWithAdditionalFilesInCurrentMonth.value ------------- ', percentTrainingsWithAdditionalFilesInCurrentMonth.value)
                console.log('countStudentsWithOverdueTariffs.value ------------- ', countStudentsWithOverdueTariffs.value)
                subParamsLoading.value = false

                clientGroupStatistics.value = (await getClientsGroupsStatistics(+clientGroupYear.value, +clientGroupMonth.value)).data
                console.log('clientGroupStatistics.value ------------- ', clientGroupStatistics.value)
                clientGroupStatisticsLoading.value = false

                multiTariffsClientsStatistics.value = (await getMultiTariffsClientsStatistics(+multiTariffsYear.value, +multiTariffsMonth.value)).data
                console.log('multiTariffsClientsStatistics.value ------------- ', multiTariffsClientsStatistics.value)
                multiTariffsClientsStatisticsLoading.value = false

                singleTariffsClientsStatistics.value = (await getSingleTariffsClientsStatistics(+singleTariffsYear.value, +singleTariffsMonth.value)).data
                console.log('singleTariffsClientsStatistics.value ------------- ', singleTariffsClientsStatistics.value)
                singleTariffsClientsStatisticsLoading.value = false

                await getAllMonthesSingleTariffsStatistics()
                await getAllMonthesMultiTariffsStatistics()
                await updateOutlaysChart()
                await updateProfitChart()
                await getTrainersStatistics()

                window.addEventListener('resize', () => {
                    screenWidth.value = window.innerWidth
                })

                resizeOutlaysBlock()
                resizeOutlaysCircleChart()
                resizeTwoLinesChart()
            })

            return {
                wayforpayBalance,
                bankBalance,
                cashboxBalance,
                investBalance,
                trainersStudentsBalances,
                balancesLoading,
                sumOfAllVirtualOutlays,
                allVirtualOutlaysCount,
                meanRealIncomeFromStudent,
                subParamsLoading,
                screenWidth,
                outlaysBarChartHeight,
                outlaysBarChartWidth,
                outlaysCircleChartHeight,
                outlaysCircleChartWidth,
                showCircleWithGap,
                twoLinesChartHeight,
                twoLinesChartWidth,
                twoLinesChartLoading,
                clubOutlaysChartData,
                clubOutlaysChartKey,
                clubOutlaysDiagramData,

                profitChartOutlaysData,
                profitChartIncomesData,
                profitChartData,

                profitChartOutlaysSum,
                profitChartIncomesSum,
                profitChartDataSum,

                allTrainers,
                allGroups,
                allStudentsCount,
                studentsInGroups,
                trainersGroupsStats,

                clubOutlaysChartDataLoaded,
                profitChartDataLoaded,
                profitChartSumLoaded,
                studentsInGroupsLoaded,
                trainersDataLoaded,
                outlaysCircleDiagramDate,
                formatNumber,
                showDetailCashless,
                countStudentsWithOverdueTariffs,
                percentTrainingsWithAdditionalFilesInCurrentMonth,
                trainersList,

                clientGroupStatistics,
                clientGroupYear,
                clientGroupMonth,
                clientGroupStatisticsLoading,

                multiTariffsClientsStatistics,
                multiTariffsClientsStatisticsLoading,
                multiTariffsYear,
                multiTariffsMonth,

                singleTariffsClientsStatistics,
                singleTariffsClientsStatisticsLoading,
                singleTariffsYear,
                singleTariffsMonth,

                singleGroupTypeMonthes,
                singleDuoTypeMonthes,
                singleSoloTypeMonthes,

                multiGroupTypeMonthes,
                multiDuoTypeMonthes,
                multiSoloTypeMonthes
            }
        },

        components: {
            BalanceCard,
            StaticAndFinanceBlock,
            CircleDiagram,
            BarOverlineChart,
            BarChart,
            CircleDiagramWithGap,
            TwoLinesBarChart,
            MinLineChart,
            MinBarChart,
            IncomesBySource,
            PercentageIncomesBySource,
            IncomesByGroups,
            TrainerRow,
            ClientStatisticChart
        }
    }
</script>

<style lang="scss" scoped>

.scrolltab::-webkit-scrollbar {
    width: 3px;
    height: 2px;               /* ширина всей полосы прокрутки */
}

.scrolltab::-webkit-scrollbar-track {
    background: transparent;        /* цвет зоны отслеживания */
}

.scrolltab::-webkit-scrollbar-thumb {
    background-color: rgba(171, 211, 237, 0.25);
    border-radius: 20px;       /* округлось бегунка */ /* отступ вокруг бегунка */
}


@media (min-width: 1410px) and (max-width: 8000px) {
    .balances-width {
        @apply w-[1205px];
    }

    .statics-width {
        @apply w-[1205px];
    }

    .incomes-by-sources {
        @apply w-[1110px];
    }

    .incomes-groups-container {
        @apply w-[1110px];
    }

    .all-income-params {
        @apply w-[250px] h-[355px];
    }

    .outlays-width {
        @apply w-[1100px];
    }
}

@media (min-width: 0px) and (max-width: 1410px) {
    .balances-width {
        @apply w-[1205px] ml-[10px];
    }

    .statics-width {
        @apply w-[1205px] ml-[10px];
    }

    .incomes-by-sources {
        @apply w-[900px];
    }

    .incomes-groups-container {
        @apply w-[900px];
    }

    .all-income-params {
        @apply w-[250px] h-[330px];
    }

    .outlays-width {
        @apply w-[880px];
    }
}

</style>